<template>
    <div class="pagination" >
        <div class="w-25 d-flex justify-content-center">
            <b-pagination v-model="actualPage" :total-rows="totalItens" pills :per-page="20" class="mt-4" size="sm">
                <template #first-text>
                    <b-icon-chevron-bar-left :class="`mr-2 icon-pagination bar ${actualPage == 1 ? 'item-pagination-disabled' : ''}`"/>
                </template>
                <template #prev-text>
                    <b-icon-chevron-left :class="`mt-1 mr-2 icon-pagination ${actualPage == 1 ? 'item-pagination-disabled' : ''}`"/>
                </template>
                    <template #page="{ page, active }">
                        <b v-if="active">{{ page }}</b>
                        <i v-else>{{ page }}</i>
                    </template>
                <template #next-text>
                    <b-icon-chevron-right :class="`mt-1 ml-2 icon-pagination ${actualPage == totalPages ? 'item-pagination-disabled' : ''}`"/>
                </template>
                <template #last-text>
                    <b-icon-chevron-bar-right :class="`ml-2 icon-pagination bar ${actualPage == totalPages ? 'item-pagination-disabled' : ''}`"/>
                </template>
            </b-pagination>
        </div>				
    </div>
</template>
<script>


export default {
    name: 'PaginationTable',
	props: {
		page: Number,
        totalPages: Number,
        totalItens: Number
        // length: Number
    },
    data(){
        return {
            actualPage: 1
        }
    },
    watch:{
        actualPage( value ){
            this.$emit("changePage", value)
        }
    }
}

</script>

<style>
html body .b-pagination-pills .page-item {
    font-family: optum-sans-bold !important;
    font-style: normal !important;

}

html body .b-pagination-pills .page-item .page-link{
    border: none;
    color: #002677;    
}

html body .b-pagination-pills .page-item.active .page-link {
    color: #fff; 
    background-color: #FF612B;
    border-color: #FF612B;
}

html body .page-link:hover {
    background-color: #ff602b2f;
}
</style>

<style scoped lang="scss">

.icon-pagination{
	font-size: 0.73em;
    margin-bottom: 2px;
    color: $primaryColor;
    font-weight: 600;
}

.icon-pagination.bar{
	font-size: 0.95em;
    margin-bottom: 0px;
}

.icon-pagination:hover{
	transform: scale(1.25);
	color: #FF612B;
	cursor: pointer;
}

.item-pagination-disabled, .item-pagination-disabled:hover{
	color: $primaryColorDisable
}

.item-pagination-disabled:hover{
	transform: none;
	cursor: initial;
}

.pagination {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>